import styled from "styled-components/macro";

export const PaginationWrapper = styled.div`
  padding: 0 12px;
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  height: 24px;

  .pagination-info {
    display: flex;
    align-items: center;
    gap: 6px;
    color: var(--Neutral-60);
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: -0.012px;

    .pagination-count {
      color: var(--Neutral-100);
      font-weight: 500;
      letter-spacing: -0.018px;
    }
  }

  .pagination-controls {
    display: flex;
    align-items: center;
    gap: 16px;

    .prev-next-icon {
      display: flex;
      cursor: pointer;
      padding: 4px 8px;
      justify-content: center;
      align-items: center;
      gap: 5px;
      color: var(--Neutral-100);
      font-size: 12px;
      font-weight: 500;
      line-height: 16px;
      letter-spacing: -0.018px;
      border-radius: 4px;

      &.disabled {
        color: var(--Neutral-40);
        cursor: default;

        &:hover {
          background: transparent;
        }
      }

      &:hover {
        background: var(--Neutral-4);
      }

      svg {
        width: 14px;
        height: 14px;
        padding: 1px;
      }

      /* &.prev-icon {
        svg {
          transform: rotate(90deg);
        }
      }

      &.next-icon {
        svg {
          transform: rotate(270deg);
        }
      } */
    }

    .pagination-number {
      display: flex;
      align-items: center;
      gap: 2px;

      .ellipsis {
        display: flex;
        width: 24px;
        justify-content: center;
        align-items: center;
      }

      .number {
        border-radius: 24px;
        min-width: 24px;
        width: auto;
        padding: 4px 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--Neutral-100);
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        cursor: pointer;
        letter-spacing: -0.018px;

        &:hover {
          background-color: var(--Neutral-4);
        }
      }

      .active {
        border-radius: 24px;
        background: var(--Neutral-100);
        color: var(--White-100);

        &:hover {
          background: var(--Neutral-100);
        }
      }
    }
  }
`;
